/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const LOGIN_URL = `${process.env.BACKEND_API_URL}api/login`;
const CHECK_AUTH = `${process.env.BACKEND_API_URL}api/auth/check`;
const SSO_EXCHANGE_URL = `${process.env.BACKEND_API_URL}api/auth/sso/exchange`;
const ACCOUNT_URL = `${process.env.BACKEND_API_URL}api/v2/account`;

const state = {
  user: {
    hasPricingRules: false,
    authenticated: false,
    data: {
      selectedRole: {},
      id: null,
    },
    paymentModuleEnabled: false,
    paymentMenuVisible: false,
    poolParkingEnabled: false,
    autopayEnabled: false,
    show_parking_spots_map: false,
    landlord_theme: '',
  },
  error: '',
};

const getters = {
  user: state => state.user,
  error: state => state.error,
};

const actions = {
  login({ commit }, payload) {
    return Vue.http.post(LOGIN_URL, payload)
      .then(async (response) => {
        Vue.http.headers.common.Authorization = `Bearer ${response.data.token}`;
        localStorage.setItem('id_token', response.data.token);
        await localStorage.setItem('user', JSON.stringify(response.data.user));
        commit(mTypes.DATA_ERROR, '');
        commit(mTypes.LOG_IN);
        return response.data.user;
      }).catch((error) => {
        if (error.status === 403 && error.data && error.data.error === 'sso_required' && error.data.key) {
          commit(mTypes.DATA_ERROR, 'sso_redirect');
          window.location.href = `${process.env.BACKEND_API_URL}sso/${error.data.key}/redirect`;
          return null;
        }
        commit(mTypes.DATA_ERROR, error.status);
      });
  },
  ssoLogin({ commit }, code) {
    return Vue.http.post(SSO_EXCHANGE_URL, { code })
      .then(async (response) => {
        Vue.http.headers.common.Authorization = `Bearer ${response.data.token}`;
        localStorage.setItem('id_token', response.data.token);
        await localStorage.setItem('user', JSON.stringify(response.data.user));
        commit(mTypes.DATA_ERROR, '');
        commit(mTypes.LOG_IN);
        return response.data.user;
      }).catch((error) => {
        commit(mTypes.DATA_ERROR, error.status);
        commit(mTypes.LOG_OUT);
        return null;
      });
  },
  logout({ commit }) {
    return commit(mTypes.LOG_OUT);
  },
  checkAuth({ commit, dispatch }, userData) {
    const finalUrl = userData && userData.selectedRole ? `${CHECK_AUTH}?id=${userData.selectedRole.id}&role=${userData.selectedRole.role}` : CHECK_AUTH;

    return Vue.http.get(finalUrl).then((response) => {
      commit('set-payment-module-status', response.data.payment_module_enabled);
      commit('set-payment-menu-visible', response.data.show_payment_menu_link);
      commit('set-pool-parking-status', response.data.pool_parking_enabled);
      commit('set-autopay-enabled', response.data.autopay_enabled);
      commit('set-show-parking-spots-map', response.data.show_parking_spots_map);
      commit('set-theme-class', response.data.landlord_theme);
      commit('set-allowed-to-download-receipts', response.data.allowed_to_download_receipts);
      if (localStorage.getItem('id_token')) {
        commit(mTypes.LOG_IN);
        return dispatch('refreshUser');
      }
      commit(mTypes.LOG_OUT);
      return null;
    }).catch(() => {
      commit(mTypes.LOG_OUT);
    });
  },
  // Long-lived sessions (e.g. the iOS/Android wrapper apps) keep serving the
  // user object stored at login time, which may predate fields like `roles`.
  // Re-fetch it on every auth check so the stored copy stays current.
  refreshUser({ commit }) {
    return Vue.http.get(ACCOUNT_URL).then((response) => {
      const freshUser = response.data.user;
      const storedUser = JSON.parse(localStorage.getItem('user'));
      const current = storedUser && storedUser.selectedRole;
      const stillValid = current && freshUser.roles
        .find(r => r.id === current.id && r.role === current.role);
      if (stillValid) {
        freshUser.selectedRole = stillValid;
      }
      localStorage.setItem('user', JSON.stringify(freshUser));
      commit(mTypes.LOG_IN);
    }).catch(() => {});
  },
  switchRole({ commit }, payload) {
    return commit(mTypes.SWITCH_ROLE, payload);
  },
};

const mutations = {
  [mTypes.LOG_IN](state) {
    state.user.data = JSON.parse(localStorage.getItem('user'));
    state.user.authenticated = true;
  },
  [mTypes.LOG_OUT](state) {
    localStorage.removeItem('id_token');
    localStorage.removeItem('user');
    state.user.authenticated = false;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
  [mTypes.SWITCH_ROLE](state, payload) {
    state.user.data.selectedRole = payload;
    localStorage.setItem('user', JSON.stringify(state.user.data));
  },
  ['set-payment-module-status'](state, status) {
    state.user.paymentModuleEnabled = status
  },
  ['set-payment-menu-visible'](state, status) {
    state.user.paymentMenuVisible = status
  },
  ['set-pool-parking-status'](state, status) {
    state.user.poolParkingEnabled = status;
  },
  ['set-autopay-enabled'](state, status) {
    state.user.autopayEnabled = status
  },
  ['set-show-parking-spots-map'](state, status) {
    state.user.show_parking_spots_map = status
  },
  ['set-theme-class'](state, status) {
    state.user.landlord_theme = status
  },
  ['set-allowed-to-download-receipts'](state, status) {
    state.user.allowed_to_download_receipts = status
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/user/user.js